import script from "./Shift.vue?vue&type=script&setup=true&lang=js"
export * from "./Shift.vue?vue&type=script&setup=true&lang=js"

import "./Shift.vue?vue&type=style&index=0&id=2824184f&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2824184f"]])

export default __exports__